import _ from "lodash";

class Config {
    static AUTH_API = _.get((window as any), "_env_.AUTH_API", "");
    static INFO_API = _.get((window as any), "_env_.INFO_API", "");
    static BACKEND_API = _.get((window as any), "_env_.BACKEND_API", "");
    static BACKEND_HOME_API = _.get((window as any), "_env_.BACKEND_HOME_API", "");
}

export default Config;